import { useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { permissionCheckFnforCamo } from '../../utils'
import { Accordion, AccordionDetails, AccordionSummary, Grid, TextField, Typography, Tooltip, IconButton, Dialog } from "@material-ui/core"
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined"
import moment from 'moment';
import InfoIcon from '@material-ui/icons/Info';
import { dayMonthDateFormat, fieldDMYShort } from "../../constants"
import EngOnOffWingList from './EngOnOffWingList'
import { acumenCamo } from "../../shared_elements/components";

const sCell = { padding: '6px 8px' };
const sLabel = { display: 'block', fontSize: '14px', fontWeight: 700, marginBottom: '2px', lineHeight: '1.4', fontFamily: "Roboto,Helvetica,Arial,sans-serif" };
const sValue = { display: 'block', fontSize: '14px', color: '#222', wordBreak: 'break-word', fontFamily: "Roboto,Helvetica,Arial,sans-serif" };

const EditButton = ({ tecSpecEdit, basicDetailData, btnType }) => {
	return (
		<div id="edit-basic-detail" className="d-flex">
			<span class="editBasicDetail">
				{!permissionCheckFnforCamo({ primaryKey: "asset_management", keyIndex: "U", }) || window?.location?.search.includes('archived-assets') || !basicDetailData?.id ? null :
					<Tooltip title="Edit" arrow placement="top">
						<IconButton className="edit-asset-icon" onClick={() => tecSpecEdit(btnType)}>
							<CreateOutlinedIcon />
						</IconButton>
					</Tooltip>
				}
			</span>
		</div>
	)
}

function TechSpecListing({ assetType, basicDetailData, assetsDetail, tecSpecEdit }) {
	const [lessMore, setLessMore] = useState({});
	const toggleLessMore = (lessMr) => {
		setLessMore({ ...lessMore, [lessMr]: !lessMore[lessMr] });
	}
	const lessMoreFn = (name, lessMr) => {
		return <>
			{name && name?.length > 50 ? (
				<>
					{lessMore[lessMr] ?
						(<> {name} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}> ..less </span> </>)
						:
						(<>{name.substring(0, 50)} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}> ..more </span> </>)
					}
				</>
			) : name || '--'
			}
		</>
	}
	return (
		<>
			{assetType == 2 && <section container id="AmpTableHeader">
				<Accordion defaultExpanded>
					<AccordionSummary expandIcon={<ExpandMoreIcon className="p-5" />} aria-controls="panel1a-content" id="panel1a-header">
						<Typography>Technical Specification</Typography>
					</AccordionSummary>
					<AccordionDetails style={{ backgroundColor: "#efefef", display: 'block' }}>

						{/* Engine Status */}
						<Grid container>
							<Grid className="left-panel" item xs={6} md={6} sm={6}>
								<h4 style={{ color: "#bd10e0", margin: '2px 0px 0px 8px' }}>Engine Status</h4>
							</Grid>
							<Grid className="left-panel" item xs={6} md={6} sm={6}>
								<EditButton tecSpecEdit={tecSpecEdit} basicDetailData={basicDetailData} btnType='engine_Status' />
							</Grid>
							<Grid item xs={12}>
								<Grid container spacing={0}>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Delivery Date</span>
											<span style={sValue}>{basicDetailData?.delivery_date_to_current_operator ? moment(basicDetailData?.delivery_date_to_current_operator).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Monthly EFH</span>
											<span style={sValue}>{assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.monthly_FH)[0] || basicDetailData?.average_monthly_hours || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Monthly EFC</span>
											<span style={sValue}>{assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.monthly_FC)[0] || basicDetailData?.average_monthly_cycles || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Next Delivery Date</span>
											<span style={sValue}>{basicDetailData?.next_delivery_date ? moment(basicDetailData?.next_delivery_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Location (A/C Reg.)</span>
											<span style={sValue}>{assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.location_reg_aircraft)[0] || basicDetailData?.new_tec_spec?.location_reg_aircraft || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Location (Position)</span>
											<span style={sValue}>{assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.location_position?.label)[0] || basicDetailData?.position?.label || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>SV Forecast Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.sv_forecast_date ? moment(basicDetailData?.new_tec_spec?.sv_forecast_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "N/A"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Location (Country)</span>
											<span style={sValue}>{assetsDetail?.sort((a, b) => b - a).map(filterId => filterId?.location_country)[0] || basicDetailData?.country || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Operating Region</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.operating_region?.name || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Operating Enviroment</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.operating_environment || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Date of Installation</span>
											<span style={sValue}>{basicDetailData?.date_of_installation ? moment(basicDetailData?.date_of_installation).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Date of Removal</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.date_of_removal ? moment(basicDetailData?.new_tec_spec?.date_of_removal).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Avg. Flight Ratio</span>
											<span style={sValue}>{basicDetailData?.avg_flight_ratio ? (basicDetailData?.avg_flight_ratio).toFixed(2) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Update Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.update_date ? moment(basicDetailData?.new_tec_spec?.update_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Preservation Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.preservation_date ? moment(basicDetailData?.new_tec_spec?.preservation_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Preservation Expiry Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.preservation_expiry_date ? moment(basicDetailData?.new_tec_spec?.preservation_expiry_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Avg. Derate %</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.avg_derate || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>SV Interval Remaining</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.sv_interval_remaining === null ? "N/A" : basicDetailData?.new_tec_spec?.sv_interval_remaining > 0 ? basicDetailData?.new_tec_spec?.sv_interval_remaining : '0'}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>MCBR</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.smbc_forecast_mcbr || '--'}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>MTBR</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.smbc_forecast_mtbr || '--'}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Service Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.service_date ? moment(basicDetailData?.new_tec_spec?.service_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Comments</span>
											<span style={sValue}>{lessMoreFn(basicDetailData?.new_tec_spec?.comments, 'comments')}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Remarks</span>
											<span style={sValue}>{lessMoreFn(basicDetailData?.new_tec_spec?.remarks, 'remarks')}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Current Status</span>
											<span style={sValue}>{basicDetailData?.sub_status?.label || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>
												Performance
												<Tooltip title="Data will be fetched into the Minipack Report when it is generated" placement="top">
													<InfoIcon size='small' style={{ verticalAlign: 'middle', fontSize: 'small', paddingLeft: '3px' ,color:'#0000008a'}} />
												</Tooltip>
											</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.performance || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>
												EGTM
												<Tooltip title="Data will be fetched into the Minipack Report when it is generated" placement="top">
													<InfoIcon size='small' style={{ verticalAlign: 'middle', fontSize: 'small', paddingLeft: '3px',color:'#0000008a' }} />
												</Tooltip>
											</span>
											<span style={sValue}>{lessMoreFn(basicDetailData?.new_tec_spec?.egtm_margin_values, 'egtm_margin_values')}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>
												EGTM As of Date
												<Tooltip title="Data will be fetched into the Minipack Report when it is generated" placement="top">
													<InfoIcon size='small' style={{ verticalAlign: 'middle', fontSize: 'small', paddingLeft: '3px',color:'#0000008a' }} />
												</Tooltip>
											</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.performance_as_of_date ? moment(basicDetailData?.new_tec_spec?.performance_as_of_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={12}>
										<EngOnOffWingList basicDetailData={basicDetailData} />
									</Grid>
								</Grid>
							</Grid>
						</Grid>

						{/* Owner and Lease */}
						<Grid container>
							<Grid className="left-panel" item xs={6} md={6} sm={6}>
								<h4 style={{ color: "#bd10e0", margin: '8px 0px 8px 8px' }}>Owner and Lease</h4>
							</Grid>
							<Grid className="left-panel" item xs={6} md={6} sm={6}>
								<EditButton tecSpecEdit={tecSpecEdit} basicDetailData={basicDetailData} btnType='owner_lease' />
							</Grid>
							<Grid item xs={12}>
								<Grid container spacing={0}>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Operator (Lessee)</span>
											<span style={sValue}>{basicDetailData?.lessee?.name || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Operator (Sub-Lessee)</span>
											<span style={sValue}>{basicDetailData?.operator?.name || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Owner of A/C</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.owner_aircraft || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Lessor</span>
											<span style={sValue}>{basicDetailData?.lessor_name?.name || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Asset owner</span>
											<span style={sValue}>{basicDetailData?.owner?.name || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Lease Start Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.lease_start_date ? moment(basicDetailData?.new_tec_spec?.lease_start_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Lease Expiry Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.lease_term_date ? moment(basicDetailData?.new_tec_spec?.lease_term_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Redelivery Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.redelivery_date ? moment(basicDetailData?.new_tec_spec?.redelivery_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Months Remaining</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.lease_term_date ? basicDetailData?.new_tec_spec?.month_remaining >= 0 ? basicDetailData?.new_tec_spec?.month_remaining : "0" :  "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Lease Status</span>
											<span style={sValue}>{basicDetailData?.status?.label || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Monthly Use Fee</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.monthly_use_fee || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Monthly LLP Fee</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.monthly_llp_fee || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Accumulated MR (Use Fee)</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.accumulated_mr || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Accumulated MR (LLP Fee)</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.accumulated_mr_llp || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>As of Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.as_of_date ? moment(basicDetailData?.new_tec_spec?.as_of_date).format(dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Date of Purchase</span>
											<span style={sValue}>{basicDetailData?.purchase_date ? moment(basicDetailData?.purchase_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
								</Grid>
							</Grid>
						</Grid>

						{/* Engine Stand/Bag */}
						<Grid container>
							<Grid className="left-panel" item xs={6} md={6} sm={6}>
								<h4 style={{ color: "#bd10e0", margin: '8px 0px 8px 8px' }}>Engine Stand/Bag</h4>
							</Grid>
							<Grid className="left-panel" item xs={6} md={6} sm={6}>
								<EditButton tecSpecEdit={tecSpecEdit} basicDetailData={basicDetailData} btnType='stand_bag' />
							</Grid>
							<Grid item xs={12}>
								<Grid container spacing={0}>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Engine Stand Prime P/N</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.engine_stand_part_number || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Engine Stand Prime S/N</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.engine_stand_serial_number || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Engine Stand Base P/N</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.engine_stand_base_pn || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Engine Stand Base S/N</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.engine_stand_base_sn || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Engine Stand Cradle P/N</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.engine_stand_cradle_pn || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Engine Stand Cradle S/N</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.engine_stand_cradle_sn || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Engine Stand Location</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.engine_stand_location || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Stand</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.stand || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Bag/Cover</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.bag || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Engine Stand Color</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.engine_stand_color || '--'}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Boot Strape PN</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.boot_strape_pn || '--'}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Stand Manufacture</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.std_manufacture || '--'}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Shock Mount Mfg Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.shock_mount_mfg_date ? moment(basicDetailData?.new_tec_spec?.shock_mount_mfg_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Shock Mount Exp Date</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.shock_mount_exp_date ? moment(basicDetailData?.new_tec_spec?.shock_mount_exp_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={4} md={2}>
										<div style={sCell}>
											<span style={sLabel}>Shock Mount Limit (Years)</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.shock_mount_limit || '--'}</span>
										</div>
									</Grid>
								</Grid>
							</Grid>
						</Grid>

						{/* Software and QEC */}
						<Grid container>
							<Grid className="left-panel" item xs={6} md={6} sm={6}>
								<h4 style={{ color: "#bd10e0", margin: '8px 0px 8px 8px' }}>Software and QEC</h4>
							</Grid>
							<Grid className="left-panel" item xs={6} md={6} sm={6}>
								<EditButton tecSpecEdit={tecSpecEdit} basicDetailData={basicDetailData} btnType='sft_qec' />
							</Grid>
							<Grid item xs={12}>
								<Grid container spacing={0}>
									<Grid item xs={6} sm={3} md={2}>
										<div style={sCell}>
											<span style={sLabel}>QEC Config.</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.qec_config || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={3} md={2}>
										<div style={sCell}>
											<span style={sLabel}>QEC P/N</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.qec_part_number || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={3} md={2}>
										<div style={sCell}>
											<span style={sLabel}>EEC Software P/N</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.eec_software_part_number || "--"}</span>
										</div>
									</Grid>
									<Grid item xs={6} sm={3} md={2}>
										<div style={sCell}>
											<span style={sLabel}>EEC Software Version</span>
											<span style={sValue}>{basicDetailData?.new_tec_spec?.eec_software_version || "--"}</span>
										</div>
									</Grid>
								</Grid>
							</Grid>
						</Grid>

					</AccordionDetails>
				</Accordion>
			</section>}
		</>
	)
}

export default TechSpecListing
